import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/Index'
import Course from '@/pages/course/Index'
import Robot from '@/pages/robot/Index'
import RobotDesc from '@/pages/robot/Desc'
import RobotTest from '@/pages/robot/Test'
import Magic from '@/pages/magic/Index'
import WechatHome from '@/pages/wechat/Home'
import Article1 from '@/pages/robot/article/1'
import Article2 from '@/pages/robot/article/2'
import Article3 from '@/pages/robot/article/3'
import Article4 from '@/pages/robot/article/4'
import Article5 from '@/pages/robot/article/5'
import Article6 from '@/pages/robot/article/6'
import Article7 from '@/pages/robot/article/7'
import DoTest from '@/pages/robot/test/DoTest'
import DoChapter from '@/pages/robot/test/DoChapter'
import TeachCourse from '@/pages/teach/TeachCourse'
import TeachVideo from '@/pages/teach/TeachVideo'
import RobotCourse from '@/pages/robot/RobotCourse'
import TeachTcenter from '@/pages/teach/TeachTcenter'
import LearnCenter from '@/pages/teach/LearnCenter'
import TcCenter from '@/pages/center/TcCenter'
import StCenter from '@/pages/center/StCenter'
import WifiCrud from '@/pages/center/WifiCrud'
import TcItem from '@/pages/center/TcItem'
import CppHome from '@/pages/cpp/Home'
import CppDesc from '@/pages/cpp/Desc'
import CppTest from '@/pages/cpp/Test'
import DoCppTest from '@/pages/cpp/test/DoTest'
import TeachScenter from '@/pages/teach/TeachScenter'
import TeachTvideo from '@/pages/teach/TeachTvideo'
import TeachSvideo from '@/pages/teach/TeachSvideo'

Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'Home',
		component: Home
	}, {
		path: '/course',
		name: 'Course',
		component: Course
	}, {
		path: '/robot/desc',
		name: 'RobotDesc',
		component: RobotDesc
	}, {
		path: '/robot/test',
		name: 'RobotTest',
		component: RobotTest
	}, {
		path: '/wechat/home',
		name: 'WechatHome',
		component: WechatHome
	}, {
		path: '/robot/article/1',
		name: 'Article1',
		component: Article1
	}, {
		path: '/robot/article/2',
		name: 'Article2',
		component: Article2
	}, {
		path: '/robot/article/3',
		name: 'Article3',
		component: Article3
	}, {
		path: '/robot/article/4',
		name: 'Article4',
		component: Article4
	}, {
		path: '/robot/article/5',
		name: 'Article5',
		component: Article5
	}, {
		path: '/robot/article/6',
		name: 'Article6',
		component: Article6
	}, {
		path: '/robot/article/7',
		name: 'Article7',
		component: Article7
	}, {
		path: '/robot/test/dotest',
		name: 'DoTest',
		component: DoTest
	}, {
		path: '/robot/test/dochapter',
		name: 'DoChapter',
		component: DoChapter
	}, {
		path: '/robot',
		name: 'Robot',
		component: Robot
	}, {
		path: '/teach/course',
		name: 'TeachCourse',
		component: TeachCourse
	}, {
		path: '/teach/video',
		name: 'TeachVideo',
		component: TeachVideo
	}, {
		path: '/robot/course',
		name: 'RobotCourse',
		component: RobotCourse
	}, {
		path: '/teach/tcenter',
		name: 'TeachTcenter',
		component: TeachTcenter
	}, {
		path: '/learn/center',
		name: 'LearnCenter',
		component: LearnCenter
	}, {
		path: '/center/tcCenter',
		name: 'TcCenter',
		component: TcCenter
	}, {
		path: '/center/stCenter',
		name: 'StCenter',
		component: StCenter
	}, {
		path: '/magic/:id',
		name: 'Magic',
		component: Magic
	}, {
		path: '/center/WifiCrud',
		name: 'WifiCrud',
		component: WifiCrud
	}, {
		path: '/center/tcitem',
		name: 'TcItem',
		component: TcItem
	}, {
		path: '/cpp',
		name: 'CppHome',
		component: CppHome
	}, {
		path: '/cpp/desc',
		name: 'CppDesc',
		component: CppDesc
	}, {
		path: '/cpp/test',
		name: 'CppTest',
		component: CppTest
	}, {
		path: '/cpp/test/dotest',
		name: 'DoCppTest',
		component: DoCppTest
	},{
		path: '/teach/scenter',
		name: 'TeachScenter',
		component: TeachScenter
	},{
		path: '/teach/tvideo',
		name: 'TeachTvideo',
		component: TeachTvideo
	},{
		path: '/teach/svideo',
		name: 'TeachSvideo',
		component: TeachSvideo
	}]
})